import React from 'react';
import { useSelector } from 'react-redux';
import {
  analyticsDataLayer,
  dispatchPageLoad,
} from 'src/redux/utils/analytics-helper';
import { RecurringBuyConfirmation } from '../RecurringBuy/RecurringBuyConfirmation';
import { getAutoSellTransanctions } from '../../../../redux/modules/executeRedemption/selectors';

export const AutoSellConfirmation: React.VFC = () => {
  const confirmationNumber = '';
  const transactions = useSelector(getAutoSellTransanctions);
  return (
    <RecurringBuyConfirmation
      {...{
        analyticsDataLayer,
        confirmationNumber,
        dispatchPageLoad,
        transactions,
      }}
    />
  );
};
